export default __webpack_public_path__ + "static/assets/c8e93dc0e9e417c53c9d8ad529cce770.svg";